"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var TicketGridDatetimeCell = /** @class */ (function () {
    function TicketGridDatetimeCell() {
        this.dateformat = 'MM/DD/YYYY h:mm A';
    }
    TicketGridDatetimeCell.prototype.agInit = function (params) {
        this.params = params;
        if (params.colDef.dateformat) {
            this.dateformat = params.colDef.dateformat;
        }
        var value = this.params && this.params.value && typeof this.params.value === 'string' ?
            this.params.value : '';
        var date = moment(value);
        this.params.value = date.isValid() ? date.format(this.dateformat) : value;
    };
    TicketGridDatetimeCell.prototype.refresh = function () {
        return false;
    };
    return TicketGridDatetimeCell;
}());
exports.TicketGridDatetimeCell = TicketGridDatetimeCell;
